import React, { useState } from "react";

// Styles
import FeeCalculationsContainer from "./FeeCalculations.styles";

// Components
import TableCell from "components/Common/TableCell/TableCell";
import Table from "components/Common/Table/Table";
import SearchOptions from "components/Common/SearchOptions/SearchOptions";
import PowerBIDashboard from "../../../../../../../Common/PowerBIDashboard";

interface FeeCalculationsProps {
    url: string;
    fund: string;
}

const FeeCalculations = ({ url, fund }: FeeCalculationsProps) => {
    const [filterQuery, setFilterQuery] = useState<string>("");

    const columns = [
        {
            id: 1,
            title: "METRIC",
            sortable: true,
            value: "metric",
            cell: (data: any) => <TableCell data={data.metric} />,
            show: true,
            fullDataRow: true,
        },
        {
            id: 2,
            title: "VALUE",
            sortable: true,
            value: "value",
            cell: (data: any) => <TableCell data={data.value} />,
            show: true,
            fullDataRow: true,
        },
    ];

    const filterOptions = [
        {
            id: 1,
            name: "Select Series",
            value: "series",
            type: "DROPDOWN",
            options: [
                { label: "Temp1", value: "TEST1" },
                { label: "Temp2", value: "TEST2" },
            ],
        },
        {
            id: 2,
            name: "Select Shareholder",
            value: "shareholder",
            type: "DROPDOWN",
            options: [
                { label: "Temp1", value: "TEST1" },
                { label: "Temp2", value: "TEST2" },
            ],
        },
    ];

    return (
        <FeeCalculationsContainer>
            {/* <SearchOptions
                    setFilterQuery={setFilterQuery}
                    options={filterOptions}
                />
                <Table
                    columns={columns}
                    url={url}
                    filterQuery={filterQuery}
                    defaultSortKey="metric"
                    defaultSortOrder="DESC"
                /> */}
            {fund === "delaware" && (
                <PowerBIDashboard
                    reportId="dab34e16-8e0b-4a27-8321-12d08e14cfbc"
                    workspaceId="ba0ccfe6-4d32-44b6-aca5-e2ac72312904"
                ></PowerBIDashboard>
            )}
        </FeeCalculationsContainer>
    );
};
export default FeeCalculations;
